module.exports = __webpack_public_path__ + "1f10fc598cd00d13d31b35dfc4f89137.MP3";